import {
	type FrontendPlacementMessage,
	type FrontendStage,
} from '@post-office/message-maker-browser/types';

import { noValidation } from '@post-office/message-maker-browser/message-helpers';

import {
	PlacementFrontend,
	type PlacementRenderProps,
} from '@post-office/browser--jira-empanada/issue-navigator-placement';

import { ListMergeSpotlightTour } from '../../../components/ListMergeSpotlightTour';

import type { CreatePlacementMessageConfig } from '@post-office/message-template-contracts/placement-v2';

export type MessageTemplateContext = {
	message: string;
};

type RenderProps = MessageTemplateContext & PlacementRenderProps;

export const MessageFrontend: (config: CreatePlacementMessageConfig) => FrontendPlacementMessage<{
	render: FrontendStage<PlacementRenderProps>;
}> = PlacementFrontend.createMessageFrontend({
	render: {
		validate: noValidation<RenderProps>(),
		Component: () => <ListMergeSpotlightTour />,
	},
});
